
import { http } from 'utils'

// map mutation imports.
import {
  SET_JOBS, SET_DRIVERS, RESET_MAP_DETAILS
} from 'vx/mutations'

// map state.
const state = {
  jobs: [],
  drivers: []
}

// map state getters.
const getters = {

}

// map actions.
const actions = {
  resetDetails ({ commit }, payload) {
    commit(RESET_MAP_DETAILS)
  },

  /**
   * Get map details.
   */
  getDetails ({ commit }, payload) {
    return http.get(`map/details`).then(response => {
      commit(SET_JOBS, response.data.jobs)
      commit(SET_DRIVERS, response.data.drivers)
      return response
    })
  }
}

// map state mutations.
const mutations = {
  /**
   * Set the jobs state.
   */
  [SET_JOBS] (state, jobs) {
    state.jobs = jobs
  },

  /**
   * Set the drivers state.
   */
  [SET_DRIVERS] (state, drivers) {
    state.drivers = drivers
  },

  [RESET_MAP_DETAILS] (state) {
    state.drivers = []
    state.jobs = []
  }
}

// Export our modules, state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/map.js